import { NgModule } from '@angular/core';

import { DefaultImageDirective } from './default-image.directive';

@NgModule({
  exports: [DefaultImageDirective],
  declarations: [DefaultImageDirective],
})
export class DefaultImageModule {
}
